import axios from "axios";

import {
  USER_REGISTRATION_IS_LOADING,
  USER_REGISTRATION_IS_LOADED_WITH_ERROR,
  USER_REGISTRATION_IS_LOADED,
  USER_LOGGING_IS_LOADING,
  USER_LOGGING_IS_LOADED_WITH_ERROR,
  USER_LOGGING_IS_LOADED,
  USER_LOGGED_OUT,
  CHECK_USER_RIGHTS,
} from "./actionTypes";

import {
  REGISTER,
  LOGIN,
  LINKEDIN_ACCESS_TOKEN,
  DELETE_USER,
  CHANGE_PASSWORD,
  REQUEST_WORKSPACE,
  CHECK_USER_RIGHTS_URL,
} from "../constants/urls";

import {
  CLIENT_ID_LINKEDIN_API,
  CLIENT_SECRET,
  REDIRECT_URI,
  GRANT_TYPE,
  WORKSPACE_TYPE_PRIVATE,
} from "../constants/stringConstants";

export function userRegistrationIsLoading(userRegistrationIsLoading) {
  return {
    type: USER_REGISTRATION_IS_LOADING,
    userRegistrationIsLoading,
  };
}

export function userRegistrationIsLoadedWithError(
  userRegistrationIsLoadedWithError,
  userRegistrationErrorMessage
) {
  return {
    type: USER_REGISTRATION_IS_LOADED_WITH_ERROR,
    userRegistrationIsLoadedWithError,
    userRegistrationErrorMessage,
  };
}

export function userRegistrationIsLoaded(userRegistrationSuccessMessage) {
  return {
    type: USER_REGISTRATION_IS_LOADED,
    userRegistrationSuccessMessage,
  };
}

export function registerUser(
  email,
  firstname,
  lastname,
  password,
  linkedin_id,
  mailing_list
) {
  return (dispatch) => {
    dispatch(userRegistrationIsLoading(true));
    axios({
      url: REGISTER,
      params: {
        email,
        firstname,
        lastname,
        password,
        linkedin_id,
        mailing_list,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        dispatch(userRegistrationIsLoaded(response.data));
      })
      .catch((err) => {
        dispatch(
          userRegistrationIsLoadedWithError(
            true,
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function userLoggingIsLoading(userLoggingIsLoading) {
  return {
    type: USER_LOGGING_IS_LOADING,
    userLoggingIsLoading,
  };
}

export function userLoggingIsLoadedWithError(
  userLoggingIsLoadedWithError,
  userLoggingErrorMessage
) {
  return {
    type: USER_LOGGING_IS_LOADED_WITH_ERROR,
    userLoggingIsLoadedWithError,
    userLoggingErrorMessage,
  };
}

export function userLoggingIsLoaded(
  workspacesOfUser,
  user,
  userToken,
  currentWorkspace
) {
  return {
    type: USER_LOGGING_IS_LOADED,
    workspacesOfUser,
    user,
    userToken,
    currentWorkspace,
  };
}

export function logInUser(username, password, linkedin_id) {
  return (dispatch) => {
    dispatch(userLoggingIsLoading(true));
    axios({
      url: LOGIN,
      params: {
        username,
        password,
        linkedin_id,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    })
      .then((response) => {
        let user = {
          USER_EMAIL: username,
          USER_TOKEN: "",
        };
        if (response.data.RegHub_response.length) {
          user.USER_TOKEN = response.data.RegHub_response.filter(
            (o) => o.PREFERRED == "1"
          )[0].USER_TOKEN;

          response.data.RegHub_response.forEach(
            (o) =>
              (o.WORKSPACE_ICON_PATH = o.WORKSPACE_ICON_PATH.replace(" ", "-"))
          );

          dispatch(
            userLoggingIsLoaded(
              response.data.RegHub_response,
              user,
              user.USER_TOKEN,
              response.data.RegHub_response.filter(
                (o) => o.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
              )[0]
            )
          );

          dispatch(checkUserRights(user.USER_TOKEN));
        } else {
          dispatch(
            userLoggingIsLoadedWithError(
              true,
              "Username or password are incorrect"
            )
          );
        }
      })
      .catch((err) => {
        dispatch(
          userLoggingIsLoadedWithError(
            true,
            err.response ? err.response.data : err
          )
        );
      });
  };
}

export function authorizeLinkedIn(code, type) {
  return (dispatch) => {
    axios({
      url: LINKEDIN_ACCESS_TOKEN,
      params: {
        grant_type: GRANT_TYPE,
        code,
        redirectUrl: REDIRECT_URI,
        client_id: CLIENT_ID_LINKEDIN_API,
        client_secret: CLIENT_SECRET,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      method: "GET",
    })
      .then((responseAccessToken) => {
        if (type === "register") {
          dispatch(
            registerUser(
              responseAccessToken.data.RegHub_response[1].elements[0]["handle~"]
                .emailAddress,
              responseAccessToken.data.RegHub_response[0].firstName.localized[
                responseAccessToken.data.RegHub_response[0].firstName
                  .preferredLocale.language +
                  "_" +
                  responseAccessToken.data.RegHub_response[0].firstName
                    .preferredLocale.country
              ],
              responseAccessToken.data.RegHub_response[0].lastName.localized[
                responseAccessToken.data.RegHub_response[0].lastName
                  .preferredLocale.language +
                  "_" +
                  responseAccessToken.data.RegHub_response[0].lastName
                    .preferredLocale.country
              ],
              "",
              responseAccessToken.data.RegHub_response[0].id
            )
          );
        } else {
          dispatch(
            logInUser(
              responseAccessToken.data.RegHub_response[1].elements[0]["handle~"]
                .emailAddress,
              "",
              responseAccessToken.data.RegHub_response[0].id
            )
          );
        }
      })
      .catch((err) => {
        //window.alert("User action", err, type);
        console.log("User action err", err);
      });
  };
}

export function loggedOut() {
  return {
    type: USER_LOGGED_OUT,
  };
}

export function deleteUser(usertoken) {
  axios({
    url: DELETE_USER,
    params: {
      usertoken,
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "GET",
  })
    .then((response) => {
      console.log("Delete user", response);
    })
    .catch((err) => {
      console.log("User action", err);
    });
}

export function changePassword(usertoken, newpassword) {
  axios({
    url: CHANGE_PASSWORD,
    params: {
      usertoken,
      new_password: newpassword,
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "GET",
  })
    .then((response) => {
      console.log("Delete user", response);
    })
    .catch((err) => {
      console.log("User action", err);
    });
}

export function requestWorkspace(usertoken) {
  axios({
    url: REQUEST_WORKSPACE,
    params: {
      usertoken,
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "GET",
  })
    .then((response) => {
      console.log("Request workspace", response);
    })
    .catch((err) => {
      console.log("Request workspace", err);
    });
}

export function userRightsChecked(userRights) {
  return {
    type: CHECK_USER_RIGHTS,
    userRights,
  };
}

export function checkUserRights(usertoken) {
  return (dispatch) => {
    axios({
      url: CHECK_USER_RIGHTS_URL,
      params: {
        usertoken,
      },
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    }).then((response) => {
      dispatch(userRightsChecked(response.data.RegHub_response));
    });
  };
}
